import { request } from '@/request/request';
import { parameterChange } from '@/utils';

export default {
  // 考核新增
  examAdd(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_info/examAdd`,
      method: 'post',
      data,
    });
  },
  // 考核更新
  examUpdate(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_info/examUpdate`,
      method: 'post',
      data,
    });
  },
  // 延长结束时间（进行中考核）
  examExtendEndTime(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_info/examExtendEndTime`,
      method: 'post',
      data,
    });
  },
  // 重置考核（清空作答数据，测试/演示转正式）
  examReset(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_info/examReset`,
      method: 'post',
      data,
    });
  },
  // 立即开始考核
  examStart(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_info/examStart`,
      method: 'post',
      data,
    });
  },
  // 立即结束考核
  examFinish(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_info/examFinish`,
      method: 'post',
      data,
    });
  },
  // 重新开启考核
  examReopen(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_info/examReopen`,
      method: 'post',
      data,
    });
  },
  // 考核列表
  examPageList(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_info/examPageList?${parameterChange(data)}`,
      method: 'get',
    });
  },
  // 考核详情
  examDetail(params) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_info/examDetail`,
      method: 'get',
      params,
    });
  },
  examCancel(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_info/examCancel`,
      method: 'post',
      data,
    });
  },
  // 考核删除
  examDelete(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_info/examDelete`,
      method: 'post',
      data,
    });
  },
  // 考核下拉列表
  examList(params) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_info/examList`,
      method: 'get',
      params,
    });
  },
  // 复制考核（快速生成新考卷）
  examCopy(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_info/examCopy`,
      method: 'post',
      data,
    });
  },
};
